

import {  Link } from "react-router-dom"
import { reduxForm , handleSubmit, FieldArray,Field, startSubmit, formValueSelector} from 'redux-form'
import {SVROFORM} from '../../constants'
import { Icon, Button as SVAButton, Row, Col, Badge } from 'antd';
import { DatePicker,Card } from 'antd';
import moment from 'moment'
import  SVARoomComponentEp  from '../core/SVARoomComponentEp'


/*reloadPage
import {loadCountriesAction} from '../../../actions'
*/
/*
import {prfLoadPrdAdDataDB as loadPrdAdDataDB } from '../../../redux/svractions/svaddressdetActions'
*/
const _ = require('lodash')
const React = require('react')
const {connect}  = require("react-redux")


  const childTypes = [{
    name:'No Child',
    value:'m0'
  },{
    name:'1 Child',
    value:'m1'
},{
    name:'2 Child',
    value:'m2'
  
  }]



  const adultTypes = [{
    name:'1 ADULT',
    value:'t1'
  },{
    name:'2 ADULT',
    value:'t2'
},{
    name:'3 ADULT',
    value:'t3'
},{
    name:'4 ADULT',
    value:'t4'
},{
    name:'5 ADULT',
    value:'t5'
},{
    name:'6 ADULT',
    value:'t6'
},{
    name:'7 ADULT',
    value:'t7'
  }]

const svsubmit =(values)=>{
    let me = this
  console.log('sv submit callback')
  console.log(values)
/*

  Promise.all([svNotifySavePromise(values)]).then((ar)=>{
      console.log('sv got promise data')

      let rs= ar[0]
      console.log(rs)
        if(rs.data.value.payload.gene){
           // me.props.geneReceptorActivate(rs.data.value.payload.gene, rs.data.value.payload)
        }
   

  })
  */
  //this.props.handleSubmit(this.props.submit('SVClassifierForm'))
}


const renderField = ({
    input,
    label,
    type,
    meta: { asyncValidating, touched, error }
  }) => (
    
     
      
      <div className={asyncValidating ? 'async-validating' : ''}>
          
        <input className="form-control" {...input} type={type} placeholder={label} />
        {touched && error && <span className="sv-form-err" >{error}</span>}
      </div>
   
  )
  

let genes = [{
    name:'add_step',
    value:'add_step'

  },{
    name:'multiply_seq_step',
    value:'multiply_seq_step'
  },{

    name:'sq_step',
    value:'sq_step'
},{
    name:'sr_step',
    value:'sr_step'
  
  }]


let svChange = (values, dispatch, props, valuesPrev)=>{

    console.log('sv form change')
  
    console.log(values)
  
  
  }


let validate =(formData)=>{
    console.log('sv--valudare fprmData')
      console.log(validate)
        const errors={}
        if(!formData){
            console.log('validate: sv formData null issue')
            return errors
        }
        if(!formData.name){
            errors.name= 'Required'
        }
        if(!formData.fname){
            errors.fname= 'Required'
        }
        if(!formData.lname){
            errors.lname= 'Required'
        }
        if(!formData.email){
            errors.email= 'Required'
        }
        if(!formData.address){
            errors.address= 'Required'
        }
        if(!formData.city){
            errors.city= 'Required'
        }
       
        if(!formData.zipcode){
            errors.zipcode= 'Required'
        }
        if(!formData.country){
            errors.country= 'Required'
        }
        if(!formData.isdcode){
            errors.isdcode= 'Required'
        }
       
        /*
         if(!formData.country){
            errors.country= 'Required'
        }
         if(!formData.state){
            errors.state= 'Required'
        }
        if(!formData.isdcode){
            errors.isdcode= 'Required'
        }
        
        if(!formData.phone){
            errors.phone= 'Required'
        }
        */
       
        return errors
    
    }
    
    let warn= (formData)=>{
        const o = {}
        if(!formData){
            console.log('sv gene null issue')
            return o
        }
        /*
        if(formData.lname <2){
            o.gene ='We expect gene to br more tham 5'
        }
        */
        return o
    }


class CreateRoomFormFormBus extends React.Component{

    constructor(props){
        
        super(props)
        let me = this
       
        this.loadGene = this.loadGene.bind(me)
        this.reloadPageSV = this.reloadPageSV(me)
        this.ddChange = this.ddChange.bind(me) 
        this.cancelPage = this.cancelPage.bind(me) 
        this.renderAddCurry = this.renderAddCurry.bind(this)
        this.renderMembersRoomCurry = this.renderMembersRoomCurry.bind(this)
       
        
        this.getAppDetails = this.getAppDetails.bind(me)
       
    }
    
    reloadPageSV=(cid)=>(e)=>{
        console.log('sv****Got the page reloadPageSV needs customerId')
        console.log(cid)
       // history.back(-1)
       

      // history.push(`/myaccountSV/6/svaddress/-1`)
        

    }

    getAppDetails(paramQSpaceId){
        //for edit we have id make it -1 for create

        let id = -1
        if(paramQSpaceId ){
            id  = parseInt(paramQSpaceId)
        }
        console.log("id* addressr det or cerate ******", id)
       //loadAddressDet(id)
        //this.props.sojDetailsAndImagesSV("mancreek") 
        /*this.props.getSojournDetails("mancreek") */
       
    }
    cancelPage(){
        console.log('cancel page')

    }
 loadGene(e){
        console.log(e)
    }


    
    ddChange(e){
        
        console.log(e)
        console.log('gene name:' +this.props.gene)

        let o = _.findWhere(genes,{value:e.target.value})
        console.log(o)
        this.props.load({
            id:o.value,
             gene:o.name
        })
        //load geneBus Componnet initialValues and form will reinitalize

    }
    renderAddCurry=(ctxThis)=>(o)=>{
        console.log('sj jun25**')
        console.log(ctxThis)
        console.log(o)
        const {fields, meta:{error, submitFailed}} =o
        fields.push()
    }
    renderMembersRoomCurry=(ctxThis)=>(o)=>{
        console.log('sj jun25**')
        console.log(o)
        if(!o){
            fields = members
        }
        const {fields, meta:{error, submitFailed}} =o
        let members =[
            {
              "documentType": "IDENTITY_CARD",
              "adultType": "t5",
              "childType": "m2",
              "holder": "Y"
            }
          ]
/*
          if(!fields){
              fields = members
          }
        console.log(o)
        */
         console.log('renderMembers should generate empty object')
        // let fields = members
           console.log(fields)
         return(<div>
            
            
             {
                  fields.map((member, index) => {
                      console.log(o)
                      
                     return(
                     <div key={index}>
                       
                       <Card title="" bordered={false} style={{ width: 300 }}>
                       <span  onClick={() => fields.remove(index)} className="c-span"><text style={{fontWeight:"700"}}>Room  #{index + 1}</text><Icon  style={{ color: 'rgb(238, 56, 56)' }} type="delete" theme="filled" /> </span>
                       <span  onClick={()=>{ fields.push()}} className="c-span"><Icon  style={{ color: 'rgb(238, 56, 56)' }} type="plus-square" theme="filled" /> </span>
                    
                      
                        <SVARoomComponentEp  childTypes={childTypes} adultTypes={adultTypes}  member={member} index={index} />
                        </Card>
                        
                      
                     </div>
                   )})
      
             }
              <div>
             <SVAButton type="link" onClick={()=>{ fields.push()}}  > Add Room </SVAButton>
             { submitFailed && error && <span>{error} </span>}
             </div>
            
            
      
             </div> )
            
      }
    renderMembersRoomCurry_ul_old=(ctxThis)=>(o)=>{
        console.log('sj jun25**')
        console.log(o)
        if(!o){
            fields = members
        }
        const {fields, meta:{error, submitFailed}} =o
        let members =[
            {
              "documentType": "IDENTITY_CARD",
              "adultType": "t5",
              "childType": "m2",
              "holder": "Y"
            }
          ]
/*
          if(!fields){
              fields = members
          }
        console.log(o)
        */
         console.log('renderMembers should generate empty object')
        // let fields = members
           console.log(fields)
         return(<ul>
             {/*  
              <li>
             <button type="button" onClick={()=>{ fields.push()}}  className="btn btn-md btn-success" > Add Room </button>
             { submitFailed && error && <span>{error} </span>}
             </li>
             */}
            
             {
                  fields.map((member, index) => {
                      console.log(o)
                      
                     return(
                     <li key={index}>
                       
                       <Card title="" bordered={true} style={{ width: 300 }}>
                       <span  onClick={() => fields.remove(index)} className="c-span"><text style={{fontWeight:"700"}}>Room  #{index + 1}</text><Icon  style={{ color: 'rgb(238, 56, 56)' }} type="delete" theme="filled" /> </span>
                       <span  onClick={()=>{ fields.push()}} className="c-span"><Icon  style={{ color: 'rgb(238, 56, 56)' }} type="plus-square" theme="filled" /> </span>
                    
                      
                        <SVARoomComponentEp  childTypes={childTypes} adultTypes={adultTypes}  member={member} index={index} />
                        </Card>
                        
                      
                     </li>
                   )})
      
             }
              <li>
             <button type="button" onClick={()=>{ fields.push()}}  className="btn btn-md btn-success" > Add Room </button>
             { submitFailed && error && <span>{error} </span>}
             </li>
            
            
      
             </ul> )
            
      }
    /*svf4 end*/
    
    render(){
        console.log('sv... SVCDnaStepFormBus 1 2 3')
        const { handleSubmit, pristine, error,reset, submitting } = this.props
       
       /*svj15 end*/
        const me = this 
        //me.gene = gene
        let initialValues = this.props.initialValues

        console.log(this.props)

        const {det} = this.props
        console.log('initialValues *** sjjun25')
            console.log(det)
        if(det && det.fname.length > 0){
            initialValues = det
        }

        let customerId = -6

        return (
            <div>
                    <form  onSubmit={handleSubmit}>
                            <div className="rev-row">
                                <div >
                                   

                                       
            
                                        <FieldArray name="members" component={this.renderMembersRoomCurry(this)} />
                                      
                                    </div>
                            </div>

                            <div>
               
            <button  type="submit" className="btn btn-success" >
            Save
            </button> 
              
        {/*  
         <SVAButton onClick={this.renderAddCurry(this)} type="submit link"  disabled={pristine || error || submitting}>
          Save
        </SVAButton> 
            
        */}
       
              
         </div>
                    </form>
            </div>
        )
                    
                    

    }
}



const selector = formValueSelector(SVROFORM)
/*
let svChange = (values, dispatch, props, valuesPrev)=>{

    console.log('sv form change')
  
    console.log(values)
  
  
  }
  */

const roForm  = reduxForm({
    form:SVROFORM,
    validate:validate,
   
    warn:warn,
    //onSubmit:svsubmit,
    onChange:svChange,
    enableReinitialize:true,
    keepDirtyOnReinitialize:true

})(CreateRoomFormFormBus)
let CreateRoomFormFormBusCom =connect((state=>{
    const { sosjournsearch} = state
    let plucked = state.movies  
    //let o = {initialValues:plucked.adData }
    let o = {initialValues:sosjournsearch.sv_room_data}
    console.log('sv*******************CrateAddressForm shoul getmy_data_addressdet start ')
    
    //selector(state, 'id')
    console.log('sv info')
    console.log(o)
    console.log('sv*******************CrateAddressForm shoul getmy_data_addressdet end ')
    
    return o
   // return plucked.adData
}),{
    //load:loadAdAction,
   // load:loadPrdAdDataDB,
    //load:loadCountriesAction,
    startSubmit:startSubmit
   
   // loadGeneTemplate:loadGeneTemplate

    
})(roForm)


export default CreateRoomFormFormBusCom
//const CreateRoomFormFormBusCom  =x